import React from 'react'
import { orderCancelQuery } from './graphql'
import { useMutation } from '@ztechapps/common.hook'
import { OrderStatusEnum } from '@ztechapps/common.contract'

export type UseCancelOrderResult = [
  () => Promise<void>,
  { loading: boolean; error: unknown; confirmOptions: Record<any, any> },
]

export const useCancelOrder = ({
  status,
  orderId,
}: {
  status: OrderStatusEnum
  orderId: string
}): UseCancelOrderResult => {
  const [updateStatus, , { loading, error }] = useMutation({ query: orderCancelQuery })

  const confirmOptions = React.useMemo(() => {
    let options = {
      text: '',
    }

    if (status === OrderStatusEnum.Paid) {
      options = {
        text: 'We will refund also the payment.',
      }
    }

    //refund and cancel the shipping label if the status is in packing
    if (status === OrderStatusEnum.Packing) {
      options = {
        text: 'We will refund the payment and cancel the shipping.',
      }
    }
    return options
  }, [status])

  const cancelOrder = async () => {
    await updateStatus({ input: { order: { _id: orderId } } })
  }

  return [cancelOrder, { loading, error, confirmOptions }]
}
